export default "__VITE_ASSET__xWMOOcCf__"